<h1 class="m-inter-t m-interSmall-b cd-text-align-center" i18n="@@ZKK_SELECTION_REQUEST">Bitte geben Sie die ZKK-Nummer des Kunden an</h1>

<form name="partnerForm" autocomplete="on" accept-charset="utf-8" (ngSubmit)="applyPartner()" class="cd-block m-inter-b">
  <div class="form-group">
    <sbb-form-field class="loginInput">
      <label i18n="@@ZKK_NUMBER_OR_CUSTOMER_NAME">ZKK Nummer oder Kundenname</label>
      <input
        #partnerSelection
        type="text"
        [formControl]="searchControl"
        [sbbAutocomplete]="auto"
        (input)="nativeInputChanged$.next($event.target.value)"
        i18n-placeholder="@@ZKK_NUMBER_OR_CUSTOMER_NAME"
        placeholder="ZKK Nummer oder Kundenname"
        name="partnerSelection"
        tabindex="1"
        autocomplete="off" />
      <sbb-autocomplete
        #auto="sbbAutocomplete"
        [trigger]="partnerSelection"
        [autoActiveFirstOption]="true"
        [autoSelectActiveOptionOnBlur]="true"
        [requireSelection]="true"
        [displayWith]="display">
        @if (arePartnersLoading) {
          <sbb-option disabled>
            <sbb-loading-indicator size="s"></sbb-loading-indicator>
          </sbb-option>
        }
        @for (option of (options$ | async) || [] | slice: 0 : MAX_PARTNERS; track option) {
          <sbb-option [value]="option"> {{ option.zkk }} - {{ option?.name }} </sbb-option>
        }
        @if (((options$ | async)?.length || 0) > MAX_PARTNERS) {
          <sbb-option-hint i18n="@@ZKK_SELECTION_FURTHER_RESULTS">
            {((options$ | async)?.length || 0) - MAX_PARTNERS, plural,
              =1 {1 weiterer Treffer gefunden}
              other {{{((options$ | async)?.length || 0) - MAX_PARTNERS}} weitere Treffer gefunden}
            }
          </sbb-option-hint>
        }
      </sbb-autocomplete>

      @if (!isErrorLoadingPartners && !partnerSelection.validity.valid) {
        <sbb-error i18n="@@ZKK_SELECTION_NUMBER_INVALID"> Die ZKK-Nummer ist ungültig. </sbb-error>
      }
      @if (isErrorLoadingPartners) {
        <sbb-error i18n="@@ZKK_SELECTION_SERVER_ERROR">Bei der Abfrage der Partner ist ein Fehler aufgetreten.</sbb-error>
      }
    </sbb-form-field>

    <sbb-button type="submit" name="applyZkkNumber" tabindex="2" iconName="arrow-right-small" i18n="@@APPLY_BUTTON">Übernehmen</sbb-button>
  </div>
</form>
